import { WhmBox, WhmFade } from "@securitize/reactjs-whm";
import { useContext, useEffect } from "react";
import { useFormikContext } from "formik";
import NameStep from "./NameStep";
import PhoneStep from "./PhoneStep";
import AccountTypeStep from "./AccountTypeStep";
import EntityInfoStep from "./EntityInfoStep";
import {
  REGISTRATION_STEP_PATHS,
  RegistrationSteps,
} from "./routing-constants";
import { MFEContext } from "../../contexts/MFEContext";
import { MIXPANEL_EVENTS } from "../../helpers/mixpanel";
import { FormType } from "./types";

const StepContainer = ({
  isOpen,
  children,
}: {
  isOpen: boolean;
  children: React.ReactNode;
}) => {
  return (
    <WhmFade in={isOpen} timeout={isOpen ? 1500 : 500}>
      <WhmBox
        sx={{
          position: "absolute",
          top: "0",
          left: "0",
          // 100vh fallback: on iOS it overshoots into the browser chrome, so
          // prefer 100dvh (visible viewport) and allow scrolling as a safety net
          height: "100vh",
          "@supports (height: 100dvh)": {
            height: "100dvh",
          },
          width: "100vw",
          padding: "64px 16px calc(16px + env(safe-area-inset-bottom)) 16px",
          overflowY: "auto",
        }}
      >
        {children}
      </WhmBox>
    </WhmFade>
  );
};

export default function MobileForm({ step }: { step: RegistrationSteps }) {
  const formik = useFormikContext<FormType>();
  const { mixPanel } = useContext(MFEContext);

  useEffect(() => {
    if (Object.keys(formik.errors).length > 0 && formik.submitCount > 0) {
      mixPanel.track(MIXPANEL_EVENTS.REGISTRATION.ERROR);
    }
  }, [formik.submitCount, mixPanel]);

  return (
    <WhmBox>
      <StepContainer isOpen={step === REGISTRATION_STEP_PATHS.name}>
        <NameStep filler={<WhmBox sx={{ flexGrow: 1 }} />} />
      </StepContainer>

      <StepContainer isOpen={step === REGISTRATION_STEP_PATHS.phone}>
        <PhoneStep filler={<WhmBox sx={{ flexGrow: 1 }} />} />
      </StepContainer>

      <StepContainer isOpen={step === REGISTRATION_STEP_PATHS.accountType}>
        <AccountTypeStep filler={<WhmBox sx={{ flexGrow: 1 }} />} />
      </StepContainer>

      <StepContainer isOpen={step === REGISTRATION_STEP_PATHS.entityInfo}>
        <EntityInfoStep filler={<WhmBox sx={{ flexGrow: 1 }} />} />
      </StepContainer>
    </WhmBox>
  );
}
